import { crimeaCities } from '../store/crimeaCities'
export function isCityInCrimeaSync(cityName) {
  if (!cityName || !crimeaCities) return false
  return crimeaCities?.includes(cityName)
}

/**
 * Updates positionData AREA_NAME if the city is in Crimea.
 */
export function ensureCrimeaArea(positionData) {
  if (!positionData || !positionData.CITY_NAME) return
  if (
    crimeaCities?.includes(positionData.CITY_NAME) &&
    (!positionData.AREA_NAME ||
      positionData.AREA_NAME === positionData.CITY_NAME)
  ) {
    positionData.AREA_NAME = 'Крым Республика'
  }
}
